/* tslint:disable */
/* eslint-disable */
/**
 * LendMore API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApplicationRequest,
    ApplicationRequestFromJSON,
    ApplicationRequestToJSON,
    ApplicationResponse,
    ApplicationResponseFromJSON,
    ApplicationResponseToJSON,
    StatusResponse,
    StatusResponseFromJSON,
    StatusResponseToJSON,
} from '../models';

export interface ApiApplicationsCreateApplicationPutRequest {
    loanAmount?: number;
    repaymentPeriod?: number;
    name?: string;
    email?: string;
    phone?: string;
    startAmount?: number;
    marketingConsent?: boolean;
}

export interface ApiApplicationsPutRequest {
    applicationRequest: ApplicationRequest;
}

export interface ApiApplicationsReferenceIdGetRequest {
    referenceId: number;
}

export interface ApiApplicationsSubmitApplicationPostRequest {
    applicationRequest: ApplicationRequest;
    id?: string;
}

/**
 * no description
 */
export class ApplicationApi extends runtime.BaseAPI {

    /**
     */
    async apiApplicationsAdwordsGetRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/applications/adwords`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiApplicationsAdwordsGet(): Promise<void> {
        await this.apiApplicationsAdwordsGetRaw();
    }

    /**
     */
    async apiApplicationsAdwordsconversionsGetRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/applications/adwordsconversions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiApplicationsAdwordsconversionsGet(): Promise<void> {
        await this.apiApplicationsAdwordsconversionsGetRaw();
    }

    /**
     */
    async apiApplicationsCreateApplicationPutRaw(requestParameters: ApiApplicationsCreateApplicationPutRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.loanAmount !== undefined) {
            queryParameters['loanAmount'] = requestParameters.loanAmount;
        }

        if (requestParameters.repaymentPeriod !== undefined) {
            queryParameters['repaymentPeriod'] = requestParameters.repaymentPeriod;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.email !== undefined) {
            queryParameters['email'] = requestParameters.email;
        }

        if (requestParameters.phone !== undefined) {
            queryParameters['phone'] = requestParameters.phone;
        }

        if (requestParameters.startAmount !== undefined) {
            queryParameters['startAmount'] = requestParameters.startAmount;
        }
        if (requestParameters.marketingConsent !== undefined) {
            queryParameters['marketingConsent'] = requestParameters.marketingConsent;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/applications/CreateApplication`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiApplicationsCreateApplicationPut(requestParameters: ApiApplicationsCreateApplicationPutRequest): Promise<string> {
        const response = await this.apiApplicationsCreateApplicationPutRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiApplicationsEnvironmentGetRaw(): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/applications/Environment`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiApplicationsEnvironmentGet(): Promise<string> {
        const response = await this.apiApplicationsEnvironmentGetRaw();
        return await response.value();
    }

    /**
     */
    async apiApplicationsPutRaw(requestParameters: ApiApplicationsPutRequest): Promise<runtime.ApiResponse<ApplicationResponse>> {
        if (requestParameters.applicationRequest === null || requestParameters.applicationRequest === undefined) {
            throw new runtime.RequiredError('applicationRequest','Required parameter requestParameters.applicationRequest was null or undefined when calling apiApplicationsPut.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/api/applications`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ApplicationRequestToJSON(requestParameters.applicationRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiApplicationsPut(requestParameters: ApiApplicationsPutRequest): Promise<ApplicationResponse> {
        const response = await this.apiApplicationsPutRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiApplicationsReferenceIdGetRaw(requestParameters: ApiApplicationsReferenceIdGetRequest): Promise<runtime.ApiResponse<StatusResponse>> {
        if (requestParameters.referenceId === null || requestParameters.referenceId === undefined) {
            throw new runtime.RequiredError('referenceId','Required parameter requestParameters.referenceId was null or undefined when calling apiApplicationsReferenceIdGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/applications/{referenceId}`.replace(`{${"referenceId"}}`, encodeURIComponent(String(requestParameters.referenceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => StatusResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiApplicationsReferenceIdGet(requestParameters: ApiApplicationsReferenceIdGetRequest): Promise<StatusResponse> {
        const response = await this.apiApplicationsReferenceIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiApplicationsSubmitApplicationPostRaw(requestParameters: ApiApplicationsSubmitApplicationPostRequest): Promise<runtime.ApiResponse<ApplicationResponse>> {
        if (requestParameters.applicationRequest === null || requestParameters.applicationRequest === undefined) {
            throw new runtime.RequiredError('applicationRequest','Required parameter requestParameters.applicationRequest was null or undefined when calling apiApplicationsSubmitApplicationPost.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/api/applications/submitApplication`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApplicationRequestToJSON(requestParameters.applicationRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiApplicationsSubmitApplicationPost(requestParameters: ApiApplicationsSubmitApplicationPostRequest): Promise<ApplicationResponse> {
        const response = await this.apiApplicationsSubmitApplicationPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiApplicationsUpdateAdserviceGetRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/applications/UpdateAdservice`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiApplicationsUpdateAdserviceGet(): Promise<void> {
        await this.apiApplicationsUpdateAdserviceGetRaw();
    }

    /**
     */
    async apiApplicationsUpdateAppsGetRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/applications/UpdateApps`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiApplicationsUpdateAppsGet(): Promise<void> {
        await this.apiApplicationsUpdateAppsGetRaw();
    }

    /**
     */
    async apiApplicationsUpdateSIBGetRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/applications/UpdateSIB`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiApplicationsUpdateSIBGet(): Promise<void> {
        await this.apiApplicationsUpdateSIBGetRaw();
    }

    /**
     */
    async apiApplicationsUpdateclicksGetRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/applications/updateclicks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiApplicationsUpdateclicksGet(): Promise<void> {
        await this.apiApplicationsUpdateclicksGetRaw();
    }

    /**
     */
    async apiApplicationsUpdatepublishersGetRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/applications/updatepublishers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiApplicationsUpdatepublishersGet(): Promise<void> {
        await this.apiApplicationsUpdatepublishersGetRaw();
    }

}
